/** Namespace `integrations` — bản gốc tiếng Việt. Khoá phẳng, tên camelCase; `{biến}` để chèn. */
export const integrations = {
  technicalDocuments: "Tài liệu kỹ thuật",
  commercialDocuments: "Hợp đồng và tài liệu thương mại",
  docsIntro: "Mở tài liệu nguồn hoặc bổ sung bản được cung cấp cho Bube. Việc đính kèm tài liệu không tự cấp quyền sử dụng.",
  docsAdd: "Bổ sung tài liệu",
  docsReferences: "Nguồn tham chiếu",
  docsOfficial: "Nguồn chính thức",
  docsThirdParty: "Tham khảo bên thứ ba",
  docsAdded: "Tài liệu đã bổ sung",
  docsEmpty: "Chưa có file hoặc URL bổ sung.",
  docsAddedBy: "Bổ sung bởi {actor}",
  docsTitle: "Tên tài liệu",
  docsKind: "Cách bổ sung",
  docsUpload: "Tải file lên",
  docsLink: "Thêm URL",
  docsFile: "Chọn file tài liệu",
  docsUrl: "URL tài liệu (HTTPS)",
  docsFileLimit: "PDF, DOCX, XLSX, TXT hoặc MD; dung lượng từ 1 byte đến 5 MiB.",
  bkavPrivateDocument: "FAQ_WebServices_Bkav được BKAV gửi trực tiếp cho đối tác, chưa có URL công khai trong danh mục. Có thể bổ sung bản file hoặc URL được BKAV cung cấp ở đây.",
  guidancePurpose: "Mục đích sử dụng",
  bkavPurpose: "Kết nối BKAV eHoadon để phát hành, tra cứu và tải hóa đơn điện tử theo khả năng được hỗ trợ.",
  productPurpose: "Thiết lập kết nối của Bube với nhà cung cấp và quản lý những ứng dụng được dùng kết nối này.",
  guidanceConditions: "Điều kiện sử dụng",
  productConditions: "Cấu hình đúng môi trường, kiểm thử đạt và có quyền mở phù hợp trước khi sử dụng. Trạng thái hiện tại được kiểm ở phần quyền và độ sẵn sàng; tài liệu tham khảo không thay thế bước phê duyệt.",
  guidanceRights: "Xem quyền mở dịch vụ",
  guidanceTechnical: "Chi tiết kết nối kỹ thuật",
  guidanceProtocol: "Giao thức",
  guidanceEndpoint: "Đường dẫn dịch vụ",
  guidanceSource: "Căn cứ triển khai",
  bkavSource: "Tài liệu BKAV cung cấp cho đối tác; các thư viện bên thứ ba bên dưới chỉ dùng để tham khảo.",

  country: "Quốc gia / thị trường",
  filterEnvironment: "Môi trường",
  allEnvironments: "Tất cả môi trường",
  filterStatus: "Trạng thái cấu hình",
  allStates: "Tất cả trạng thái",
  stateEnabled: "Đang bật",
  stateDisabled: "Chưa bật",
  statusFilterHint: "Trạng thái theo app và môi trường đã chọn. Bật cấu hình chưa đồng nghĩa đã đủ quyền hoặc kiểm thử để sử dụng. Sản phẩm sắp tích hợp hiện khi chọn tất cả môi trường và trạng thái.",

  title: "Tích hợp",
  titleForApp: "Tích hợp · {app}",
  introBefore: "Quản lý tài khoản ",
  introOfBube: "của Bube",
  introMiddle: " với nhà cung cấp. Mỗi lần đổi cấu hình cần ",
  introShared: "kiểm thử và kích hoạt riêng",
  introAfter: ". Ứng dụng chỉ dùng cấu hình đã kích hoạt; tài khoản phòng thử không được gán cho ứng dụng.",
  onlyForApp: "Chỉ hiện sản phẩm {app} dùng được.",
  officialBefore: "Cố định theo ",
  officialLink: "tài liệu chính thức",
  officialAfter: " — đổi trong mã, không sửa ở đây.",
  allServices: "Tất cả dịch vụ",
  serviceFilterAria: "Lọc theo loại dịch vụ",
  emptyForFilter: "Không có tích hợp nào khớp bộ lọc.",
  marketGlobal: "Toàn cầu",
  allMarkets: "Tất cả thị trường",
  marketFilterAria: "Lọc theo thị trường",
  seeAll: "Xem mọi tích hợp",
  loadFailed: "Không đọc được danh sách tích hợp.",
  noSecretsKeyBefore: "Hub chưa có ",
  noSecretsKeyAfter: " — chưa lưu được trường bí mật, và app chưa đọc được sản phẩm nào có trường bí mật.",
  emptyForApp: "App này không dùng tích hợp đối tác nào.",
  appChipTitle: "Tích hợp của {app}",
  serviceCount: "{n} dịch vụ",
  serviceCountOne: "1 dịch vụ",
  enabledCount: "{n} đang bật",
  configure: "Cấu hình",
  usedBy: "Dùng cho",
  environment: "Môi trường",
  inUse: "Đang dùng",
  notOnHub: "Chưa lên hub",
  tenants: "khách",
  lastActivity: "cuối {when}",
  costMonth: "Phí đối tác ước tính tháng này: {amount} ({count} giao dịch)",
  costPrevMonth: "Tháng trước: {amount}",
  costQuotaWarn: "Đã dùng {pct}% hạn mức giao dịch của tháng",
  appNotConnected: "Chưa nối app",
  usageReadFailed: "Không đọc được",
  "env.unsupported": "Không hỗ trợ",
  "env.enabled": "Đang bật",
  "env.alwaysOn": "Luôn bật",
  "env.alwaysOnMissing": "Luôn bật · thiếu thông số",
  "env.completeOff": "Đủ · đang tắt",
  "env.missing": "Thiếu thông số",
  "env.notConfigured": "Chưa cấu hình",
  "envTab.sandbox": "Sandbox (thử)",
  "envTab.live": "Live (thật)",
  dialogTitle: "Cấu hình {name}",
  dialogUsedBy: "dùng cho {apps}",
  sharedNotice: "Sản phẩm dùng chung cho {n} app ({apps}): mỗi ứng dụng chọn kết nối riêng. Phiên bản chờ không thay cấu hình đang phục vụ. Kích hoạt phiên bản mới có thể ảnh hưởng mọi ứng dụng đang dùng kết nối đó.",
  envUnsupportedTitle: "{name} không có môi trường này",
  keepSecretPlaceholder: "Để trống = giữ nguyên",
  emptySecretPlaceholder: "Chưa điền",
  saved: "Đã lưu.",
  savedAndEnabled: "Đã lưu và BẬT.",
  disabledDone: "Đã TẮT.",
  saveFailed: "Không lưu được.",
  testFailed: "Không kiểm tra được.",
  stateOn: "Đang BẬT",
  stateOff: "Đang tắt",
  requiredComplete: "đủ thông số bắt buộc",
  requiredIncomplete: "chưa đủ thông số bắt buộc",
  testAuthTitle: "Gọi đối tác để xác thực khoá",
  testReachTitle: "Chỉ kiểm máy chủ đối tác trả lời",
  testing: "Đang kiểm tra…",
  testCredentials: "Kiểm tra thông số",
  testConnection: "Kiểm tra kết nối",
  confirmDisableMulti: "Tắt cho mọi khách của {n} app?",
  confirmDisable: "Tắt cho mọi khách?",
  disable: "Tắt",
  saveAndEnable: "Lưu & bật",
  "test.authOk": "Thông số ĐÚNG",
  "test.reachOk": "Máy chủ trả lời — chưa xác thực khoá",
  "test.failed": "Không đạt",
  "test.inconclusive": "Không kết luận được",
  "inbound.title": "Webhook production — dán vào cổng đối tác",
  "inbound.intro": "Đối tác gọi THẲNG app, không qua hub. Mỗi bộ khoá chỉ có một URL webhook ⇒ khoá dùng cho production phải trỏ đúng URL dưới đây; phòng thử dùng bộ khoá riêng.",
  "inbound.envLive": "Live",
  "inbound.envSandbox": "Sandbox",
  "inbound.channelIpn": "IPN",
  "inbound.channelEvents": "Sự kiện",
  "inbound.copy": "Chép",
  "inbound.copied": "Đã chép",
} as const;
